<template>
    <div>
        <table class="table">
            <tbody>
                <tr style="height: 10px;">
                    <th>{{$t('stats.min')}}</th>
                    <th>{{$t('stats.max')}}</th>
                    <th>{{$t('stats.mean')}}</th>
                    <th>{{$t('stats.std')}}</th>
                </tr>
                <tr>
                    <td>{{`${stats.min} ${unit}`}}</td>
                    <td>{{`${stats.max} ${unit}`}}</td>
                    <td>{{`${stats.mean} ${unit}`}}</td>
                    <td>{{`${stats.std} ${unit}`}}</td>
                </tr>
                <tr v-if="recupValues.length != 0">
                    <td colspan="4">{{$t('stats.recup')}}</td>
                </tr>
                <tr v-if="recupValues.length != 0">
                    <td>{{`${stats.recupMin} ${unit}`}}</td>
                    <td>{{`${stats.recupMax} ${unit}`}}</td>
                    <td>{{`${stats.recupMean} ${unit}`}}</td>
                    <td></td>
                </tr>
            </tbody> 
        </table>
    </div>
</template>
<script>

import * as helpers from '../helpers.js'

export default {
    components:{
    },

    props:{
        carac:String,
        precision:Number,
        parcel:Object,
        values:Array,
        recupValues:Array
    },
    
    data() {
        return {
            lang: navigator.language
        }
    },

    computed:{

        stats: function(){
            if (this.parcel != null){
                return this.computeStats()
            } else {
                return {"min":"", "max":"", "mean" : "", "std" : "", "recupMin":"", "recupMax":"", "recupMean": "", "recupStd": ""}
            }
        },
        unit(){
            return this.$t(`caracs.${this.carac}.unit`)
        }
    },

    methods: {
        computeStats(){
            let length = this.values.length
            let min = Math.min(...this.values);
            let max = Math.max(...this.values);
            let mean = this.values.reduce((acc, curr)=>{
                return acc + curr
            }, 0) / length;
            // Assigning (value - mean) ^ 2 to every array item
            let tempValues = this.values.map((k)=>{
                return (k - mean) ** 2
            })
            // Calculating the sum of updated array
            let sum = tempValues.reduce((acc, curr)=> acc + curr, 0);
            // Calculating the variance
            let variance = sum / length;
            // Returning the Standered deviation
            let std = Math.sqrt(variance);

            let recupMin;
            let recupMax;
            let recupMean;
            let recupStd;

            if (this.recupValues){
                recupMin = Math.min(...this.recupValues);
                recupMax = Math.max(...this.recupValues);
                recupMean = this.recupValues.reduce((acc, curr)=>{
                    return acc + curr
                }, 0) / length;
                // Assigning (value - mean) ^ 2 to every array item
                let tempValues = this.recupValues.map((k)=>{
                    return (k - mean) ** 2
                })
                // Calculating the sum of updated array
                let sum = tempValues.reduce((acc, curr)=> acc + curr, 0);
                // Calculating the variance
                let variance = sum / length;
                // Returning the Standered deviation
                recupStd = Math.sqrt(variance);
            }

            return {
                "min": min.toLocaleString(this.lang, {maximumFractionDigits: this.precision}),
                "max": max.toLocaleString(this.lang, {maximumFractionDigits: this.precision}),
                "mean": mean.toLocaleString(this.lang, {maximumFractionDigits: this.precision}),
                "std": std.toLocaleString(this.lang, {maximumFractionDigits: this.precision}),
                "recupMin": recupMin.toLocaleString(this.lang, {maximumFractionDigits: this.precision}),
                "recupMax": recupMax.toLocaleString(this.lang, {maximumFractionDigits: this.precision}),
                "recupMean": recupMean.toLocaleString(this.lang, {maximumFractionDigits: this.precision}),
                "recupStd": recupStd.toLocaleString(this.lang, {maximumFractionDigits: this.precision}),
            };
        },
    },
}
</script>
<style scoped>
.table th, .table td {
    padding:0.5rem;
}
.table th {
    border-top: none;
}

</style>